import React, { useState } from "react";
import t from "../../../helpers/t";
import Loader from "../../../components/Loader";
import SidebarFilter from "../../../components/SidebarFilter";
import { Biscuit } from "../../../../utils";
import { $, moment } from "../../../../../vendor";

const AppErrorsSidebar = (props) => {
  let language = Biscuit.get("user.lang").replace("-", "_");

  const [ready, setReady] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(); // default values?

  const [clientId, setClientId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [reservationId, setReservationId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  /**
   * can be generally defined in common sidebar
   * @param {event} ev
   */
  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  const selectedDateHandle = (date) => {
    var clone = { ...globalFilter };

    clone.day = moment(date).format("YYYY-MM-DD");
    setGlobalFilter(clone);
    setSelectedDate(date);
    // reset month and quick filter
    props.filterChangedHandle(clone);
  };

  const dateKeyDownHandle = (e) => {
    console.log("key down date: ", e);
  };

  const onClientIdSelectHandle = (query) => {
    if (typeof query !== "string") {
      query = query.target.value;
    }
    // should vaildate filter combo
    var clone = { ...globalFilter };
    setClientId(query);
    clone.client_id = query;
    setGlobalFilter(clone);

    // fetch wallet transactions
    props.filterChangedHandle(clone);
  };

  const onReservationIdSelectHandle = (query) => {
    if (typeof query !== "string") {
      query = query.target.value;
    }
    // should vaildate filter combo
    var clone = { ...globalFilter };
    setReservationId(query);
    clone.reservation_id = query;
    setGlobalFilter(clone);

    // fetch wallet transactions
    props.filterChangedHandle(clone);
  };

  const onOrderIdSelectHandle = (query) => {
    if (typeof query !== "string") {
      query = query.target.value;
    }
    // should vaildate filter combo
    var clone = { ...globalFilter };
    setOrderId(query);
    clone.order_id = query;
    setGlobalFilter(clone);

    // fetch wallet transactions
    props.filterChangedHandle(clone);
  };

  const onUserIdSelectHandle = (query) => {
    if (typeof query !== "string") {
      query = query.target.value;
    }
    // should vaildate filter combo
    var clone = { ...globalFilter };
    setUserId(query);
    clone.user_id = query;
    setGlobalFilter(clone);

    // fetch wallet transactions
    props.filterChangedHandle(clone);
  };

  const initialize = () => {
    if (ready) return;
    setReady(true);
  };

  if (!ready) initialize();

  return (
    <aside id="inb-c-sidebar" className="filemanager-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title sticky-top">
        <h1 className="inb-page-title">{props.heading}</h1>
      </header>

      {!ready && <Loader mediumWidth={4} smallWidth={4} subLoaders={2} />}
      {ready && (
        <>
          <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
            <span className="inb-list-title">{t("Client ID", null, "capital")}</span>
            <br />
            <input
              className="inbooma-input"
              name="client_id"
              key={"sidebar_search_client_id"}
              style={{ maxWidth: "180px" }}
              onChange={(e) => onClientIdSelectHandle(e)}
              value={clientId}
            ></input>
            {clientId !== undefined && clientId !== null && clientId !== "" && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => onClientIdSelectHandle("")}
                style={{ float: "unset", paddingLeft: "5px" }}
              >
                x
              </a>
            )}
          </ul>

          <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
            <span className="inb-list-title">{t("Reservation ID", null, "capital")}</span>
            <br />
            <input
              className="inbooma-input"
              name="reservation_id"
              key={"sidebar_search_reservation_i"}
              style={{ maxWidth: "180px" }}
              onChange={(e) => onReservationIdSelectHandle(e)}
              value={reservationId}
            ></input>
            {reservationId !== undefined && reservationId !== null && reservationId !== "" && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => onReservationIdSelectHandle("")}
                style={{ float: "unset", paddingLeft: "5px" }}
              >
                x
              </a>
            )}
          </ul>

          <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
            <span className="inb-list-title">{t("Order ID", null, "capital")}</span>
            <br />
            <input
              className="inbooma-input"
              name="order_id"
              key={"sidebar_search_order_id"}
              style={{ maxWidth: "180px" }}
              onChange={(e) => onOrderIdSelectHandle(e)}
              value={orderId}
            ></input>
            {orderId !== undefined && orderId !== null && orderId !== "" && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => onOrderIdSelectHandle("")}
                style={{ float: "unset", paddingLeft: "5px" }}
              >
                x
              </a>
            )}
          </ul>

          <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
            <span className="inb-list-title">{t("User ID", null, "capital")}</span>
            <br />
            <input
              className="inbooma-input"
              name="user_id"
              key={"sidebar_search_user_id"}
              style={{ maxWidth: "180px" }}
              onChange={(e) => onUserIdSelectHandle(e)}
              value={userId}
            ></input>
            {userId !== undefined && userId !== null && userId !== "" && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => onUserIdSelectHandle("")}
                style={{ float: "unset", paddingLeft: "5px" }}
              >
                x
              </a>
            )}
          </ul>
          <SidebarFilter
            id="inb-c-left-bar-flist--errors-date"
            heading={t("timespan", null, "capital")}
            type="datePicker"
            data={[
              {
                name: "date",
                className: "noBorders-noBackground",
                dateFormat: "dd.MM.y",
                selected: selectedDate,
                onChangeHandle: selectedDateHandle,
                onKeyDownHandle: dateKeyDownHandle,
                placeholder: t("created", null, "capital") + " ...",
              },
            ]}
          />
        </>
      )}
      <footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
        <a
          href="#"
          id="toggle-left-bar"
          className="button secondary show-for-small-only"
          onClick={(e) => onToggleLeftBar(e)}
        >
          <i className="fi fi-filter"></i>
          <span className="show-for-sr">t('open_filter_menu')</span>
        </a>
      </footer>
    </aside>
  );
};

export default AppErrorsSidebar;
